/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FindPro,
  MergedGroupMember,
  PatchedProGroupUpdateRequest,
  ProGroup,
  ProGroupDuplication,
  ProGroupDuplicationRequest,
  ProGroupListItem,
  ProGroupMember,
  ProGroupMemberRequest,
  ProGroupRequest,
  ProGroupUpdate,
  ProGroupUpdateRequest,
  ProGroupsListParams,
  ProGroupsMergedMembersListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProGroupsListUrl = (params?: ProGroupsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro-groups/?${stringifiedParams}` : `/api/pro-groups/`
}

/**
 * The pro-groups list endpoint is intentionally not paginated (group
 * member lists are small).
 *
 * When the optional ``gig_id`` query param is present and HD gates are
 * open, member previews come back with ``_is_high_demand`` annotated
 * (``get_queryset`` threads the HD prefetch through ``with_member_stats``).
 * When absent, the serializer's ``default=False`` keeps the field stable
 * with zero compute.
 */
export const proGroupsList = async (params?: ProGroupsListParams, options?: Parameters<typeof customFetch>[1]): Promise<ProGroupListItem[]> => {

  return customFetch<ProGroupListItem[]>(getProGroupsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProGroupsListQueryKey = (params?: ProGroupsListParams,) => {
    return [
    `/api/pro-groups/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof proGroupsList>>, TError = void>(params?: ProGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProGroupsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proGroupsList>>> = ({ signal }) => proGroupsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProGroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof proGroupsList>>>
export type ProGroupsListQueryError = void


export function useProGroupsList<TData = Awaited<ReturnType<typeof proGroupsList>>, TError = void>(
 params: undefined |  ProGroupsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsList<TData = Awaited<ReturnType<typeof proGroupsList>>, TError = void>(
 params?: ProGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsList<TData = Awaited<ReturnType<typeof proGroupsList>>, TError = void>(
 params?: ProGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProGroupsList<TData = Awaited<ReturnType<typeof proGroupsList>>, TError = void>(
 params?: ProGroupsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProGroupsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProGroupsCreateUrl = () => {




  return `/api/pro-groups/`
}

/**
 * Named groups of pros created by managers for organizing talent.
 *
 * Groups can be used for quick direct-offer gig assignment, and can be
 * duplicated across locations.
 */
export const proGroupsCreate = async (proGroupRequest: ProGroupRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProGroup> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProGroup>(getProGroupsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proGroupRequest)
  }
);}





export const getProGroupsCreateMutationKey = () => ['proGroupsCreate'] as const;

export const getProGroupsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsCreate>>, TError,ProGroupsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsCreate>>, TError,ProGroupsCreateMutationVariables, TContext> => {

const mutationKey = getProGroupsCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsCreate>>, ProGroupsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  proGroupsCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsCreate>>>
    export type ProGroupsCreateMutationBody = ProGroupRequest
    export type ProGroupsCreateMutationError = void
    export type ProGroupsCreateMutationVariables = {data: ProGroupRequest}

    export const useProGroupsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsCreate>>, TError,ProGroupsCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsCreate>>,
        TError,
        ProGroupsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsCreateMutationOptions(options), queryClient);
    }
    export const getProGroupsMembersListUrl = (groupId: number,) => {




  return `/api/pro-groups/${groupId}/members/`
}

/**
 * Manages membership of pros within a specific pro group.
 * @deprecated
 */
export const proGroupsMembersList = async (groupId: number, options?: Parameters<typeof customFetch>[1]): Promise<FindPro[]> => {

  return customFetch<FindPro[]>(getProGroupsMembersListUrl(groupId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProGroupsMembersListQueryKey = (groupId: number,) => {
    return [
    `/api/pro-groups/${groupId}/members/`
    ] as const;
    }


export const getProGroupsMembersListQueryOptions = <TData = Awaited<ReturnType<typeof proGroupsMembersList>>, TError = void>(groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProGroupsMembersListQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proGroupsMembersList>>> = ({ signal }) => proGroupsMembersList(groupId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProGroupsMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof proGroupsMembersList>>>
export type ProGroupsMembersListQueryError = void


export function useProGroupsMembersList<TData = Awaited<ReturnType<typeof proGroupsMembersList>>, TError = void>(
 groupId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsMembersList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsMembersList<TData = Awaited<ReturnType<typeof proGroupsMembersList>>, TError = void>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsMembersList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsMembersList<TData = Awaited<ReturnType<typeof proGroupsMembersList>>, TError = void>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useProGroupsMembersList<TData = Awaited<ReturnType<typeof proGroupsMembersList>>, TError = void>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProGroupsMembersListQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProGroupsMembersCreateUrl = (groupId: number,) => {




  return `/api/pro-groups/${groupId}/members/`
}

/**
 * Manages membership of pros within a specific pro group.
 */
export const proGroupsMembersCreate = async (groupId: number,
    proGroupMemberRequest: ProGroupMemberRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProGroupMember> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProGroupMember>(getProGroupsMembersCreateUrl(groupId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proGroupMemberRequest)
  }
);}





export const getProGroupsMembersCreateMutationKey = () => ['proGroupsMembersCreate'] as const;

export const getProGroupsMembersCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersCreate>>, TError,ProGroupsMembersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersCreate>>, TError,ProGroupsMembersCreateMutationVariables, TContext> => {

const mutationKey = getProGroupsMembersCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsMembersCreate>>, ProGroupsMembersCreateMutationVariables> = (props) => {
          const {groupId,data} = props ?? {};

          return  proGroupsMembersCreate(groupId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsMembersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsMembersCreate>>>
    export type ProGroupsMembersCreateMutationBody = ProGroupMemberRequest
    export type ProGroupsMembersCreateMutationError = void
    export type ProGroupsMembersCreateMutationVariables = {groupId: number;data: ProGroupMemberRequest}

    export const useProGroupsMembersCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersCreate>>, TError,ProGroupsMembersCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsMembersCreate>>,
        TError,
        ProGroupsMembersCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsMembersCreateMutationOptions(options), queryClient);
    }
    export const getProGroupsMembersDestroyUrl = (groupId: number,
    id: number,) => {




  return `/api/pro-groups/${groupId}/members/${id}/`
}

/**
 * Manages membership of pros within a specific pro group.
 */
export const proGroupsMembersDestroy = async (groupId: number,
    id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getProGroupsMembersDestroyUrl(groupId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProGroupsMembersDestroyMutationKey = () => ['proGroupsMembersDestroy'] as const;

export const getProGroupsMembersDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersDestroy>>, TError,ProGroupsMembersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersDestroy>>, TError,ProGroupsMembersDestroyMutationVariables, TContext> => {

const mutationKey = getProGroupsMembersDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsMembersDestroy>>, ProGroupsMembersDestroyMutationVariables> = (props) => {
          const {groupId,id} = props ?? {};

          return  proGroupsMembersDestroy(groupId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsMembersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsMembersDestroy>>>

    export type ProGroupsMembersDestroyMutationError = void
    export type ProGroupsMembersDestroyMutationVariables = {groupId: number;id: number}

    export const useProGroupsMembersDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsMembersDestroy>>, TError,ProGroupsMembersDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsMembersDestroy>>,
        TError,
        ProGroupsMembersDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsMembersDestroyMutationOptions(options), queryClient);
    }
    export const getProGroupsUpdateUrl = (id: number,) => {




  return `/api/pro-groups/${id}/`
}

/**
 * Named groups of pros created by managers for organizing talent.
 *
 * Groups can be used for quick direct-offer gig assignment, and can be
 * duplicated across locations.
 */
export const proGroupsUpdate = async (id: number,
    proGroupUpdateRequest: ProGroupUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProGroupUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProGroupUpdate>(getProGroupsUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proGroupUpdateRequest)
  }
);}





export const getProGroupsUpdateMutationKey = () => ['proGroupsUpdate'] as const;

export const getProGroupsUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsUpdate>>, TError,ProGroupsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsUpdate>>, TError,ProGroupsUpdateMutationVariables, TContext> => {

const mutationKey = getProGroupsUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsUpdate>>, ProGroupsUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proGroupsUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsUpdate>>>
    export type ProGroupsUpdateMutationBody = ProGroupUpdateRequest
    export type ProGroupsUpdateMutationError = void
    export type ProGroupsUpdateMutationVariables = {id: number;data: ProGroupUpdateRequest}

    export const useProGroupsUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsUpdate>>, TError,ProGroupsUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsUpdate>>,
        TError,
        ProGroupsUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsUpdateMutationOptions(options), queryClient);
    }
    export const getProGroupsPartialUpdateUrl = (id: number,) => {




  return `/api/pro-groups/${id}/`
}

/**
 * Named groups of pros created by managers for organizing talent.
 *
 * Groups can be used for quick direct-offer gig assignment, and can be
 * duplicated across locations.
 */
export const proGroupsPartialUpdate = async (id: number,
    patchedProGroupUpdateRequest?: PatchedProGroupUpdateRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProGroupUpdate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProGroupUpdate>(getProGroupsPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedProGroupUpdateRequest)
  }
);}





export const getProGroupsPartialUpdateMutationKey = () => ['proGroupsPartialUpdate'] as const;

export const getProGroupsPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsPartialUpdate>>, TError,ProGroupsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsPartialUpdate>>, TError,ProGroupsPartialUpdateMutationVariables, TContext> => {

const mutationKey = getProGroupsPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsPartialUpdate>>, ProGroupsPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proGroupsPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsPartialUpdate>>>
    export type ProGroupsPartialUpdateMutationBody = PatchedProGroupUpdateRequest | undefined
    export type ProGroupsPartialUpdateMutationError = void
    export type ProGroupsPartialUpdateMutationVariables = {id: number;data?: PatchedProGroupUpdateRequest}

    export const useProGroupsPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsPartialUpdate>>, TError,ProGroupsPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsPartialUpdate>>,
        TError,
        ProGroupsPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsPartialUpdateMutationOptions(options), queryClient);
    }
    export const getProGroupsDestroyUrl = (id: number,) => {




  return `/api/pro-groups/${id}/`
}

/**
 * Named groups of pros created by managers for organizing talent.
 *
 * Groups can be used for quick direct-offer gig assignment, and can be
 * duplicated across locations.
 */
export const proGroupsDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getProGroupsDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getProGroupsDestroyMutationKey = () => ['proGroupsDestroy'] as const;

export const getProGroupsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsDestroy>>, TError,ProGroupsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsDestroy>>, TError,ProGroupsDestroyMutationVariables, TContext> => {

const mutationKey = getProGroupsDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsDestroy>>, ProGroupsDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  proGroupsDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsDestroy>>>

    export type ProGroupsDestroyMutationError = void
    export type ProGroupsDestroyMutationVariables = {id: number}

    export const useProGroupsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsDestroy>>, TError,ProGroupsDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsDestroy>>,
        TError,
        ProGroupsDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsDestroyMutationOptions(options), queryClient);
    }
    export const getProGroupsDuplicateCreateUrl = (id: number,) => {




  return `/api/pro-groups/${id}/duplicate/`
}

/**
 * This is very similar to the regular create group with the only difference
 * duplication will copy automatically all the members to the cloned group
 * see ProGroup.objects.duplicate
 */
export const proGroupsDuplicateCreate = async (id: number,
    proGroupDuplicationRequest: ProGroupDuplicationRequest, options?: Parameters<typeof customFetch>[1]): Promise<ProGroupDuplication> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<ProGroupDuplication>(getProGroupsDuplicateCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(proGroupDuplicationRequest)
  }
);}





export const getProGroupsDuplicateCreateMutationKey = () => ['proGroupsDuplicateCreate'] as const;

export const getProGroupsDuplicateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsDuplicateCreate>>, TError,ProGroupsDuplicateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proGroupsDuplicateCreate>>, TError,ProGroupsDuplicateCreateMutationVariables, TContext> => {

const mutationKey = getProGroupsDuplicateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proGroupsDuplicateCreate>>, ProGroupsDuplicateCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proGroupsDuplicateCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProGroupsDuplicateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proGroupsDuplicateCreate>>>
    export type ProGroupsDuplicateCreateMutationBody = ProGroupDuplicationRequest
    export type ProGroupsDuplicateCreateMutationError = void
    export type ProGroupsDuplicateCreateMutationVariables = {id: number;data: ProGroupDuplicationRequest}

    export const useProGroupsDuplicateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proGroupsDuplicateCreate>>, TError,ProGroupsDuplicateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proGroupsDuplicateCreate>>,
        TError,
        ProGroupsDuplicateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProGroupsDuplicateCreateMutationOptions(options), queryClient);
    }
    export const getProGroupsMergedMembersListUrl = (params: ProGroupsMergedMembersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro-groups/members/?${stringifiedParams}` : `/api/pro-groups/members/`
}

/**
 * Preferred endpoint for listing pro group members. Supports multiple groups.
 *
 * Returns deduplicated members across one or more pro groups. Accepts a list of
 * group IDs via the group_ids query parameter and returns the union of their members.
 * Replaces the deprecated list single-group endpoint (ProGroupMembersView).
 *
 * Note: Intentionally not paginated. Group member lists are small enough to return
 * in a single response. Add pagination if group sizes grow significantly.
 */
export const proGroupsMergedMembersList = async (params: ProGroupsMergedMembersListParams, options?: Parameters<typeof customFetch>[1]): Promise<MergedGroupMember[]> => {

  return customFetch<MergedGroupMember[]>(getProGroupsMergedMembersListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProGroupsMergedMembersListQueryKey = (params?: ProGroupsMergedMembersListParams,) => {
    return [
    `/api/pro-groups/members/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProGroupsMergedMembersListQueryOptions = <TData = Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError = void>(params: ProGroupsMergedMembersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProGroupsMergedMembersListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proGroupsMergedMembersList>>> = ({ signal }) => proGroupsMergedMembersList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProGroupsMergedMembersListQueryResult = NonNullable<Awaited<ReturnType<typeof proGroupsMergedMembersList>>>
export type ProGroupsMergedMembersListQueryError = void


export function useProGroupsMergedMembersList<TData = Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError = void>(
 params: ProGroupsMergedMembersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsMergedMembersList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsMergedMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsMergedMembersList<TData = Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError = void>(
 params: ProGroupsMergedMembersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proGroupsMergedMembersList>>,
          TError,
          Awaited<ReturnType<typeof proGroupsMergedMembersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProGroupsMergedMembersList<TData = Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError = void>(
 params: ProGroupsMergedMembersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProGroupsMergedMembersList<TData = Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError = void>(
 params: ProGroupsMergedMembersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proGroupsMergedMembersList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProGroupsMergedMembersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






